export const apiUrlV3 = `/${process.env.REACT_APP_OLDAPI_VERSION}/`;
export const apiUrlV4 = `/${process.env.REACT_APP_NEWAPI_VERSION}/`;
